import '/assets/css/main.css';
import '/assets/css/xl-treffen.css';
import jQuery from 'jquery';
import { XLAnmeldung, XLSettings, XLTreffenData, XXLAnmeldungResponse } from './XLTreffenData';
import { StringTool } from '../tools/StringTool';

export class XLTreffen {

    settings: XLSettings;

    constructor(){

        let headers: [string, string][] = [["content-type", "text/json"]];

        XLTreffenData.fetchSettings().then((settings) => {

            this.settings = settings;

            if(settings.datum != null && settings.datum.indexOf('-') > 0){
                let d = new Date(settings.datum);
                $('#datum').text(d.getDate() + "." + (d.getMonth() + 1) + "." + d.getFullYear());
                $('#jahr').text(d.getFullYear());
            } else {
                $('#datum').text("????");
                let d = new Date();
                let year = d.getFullYear();
                if(d.getMonth() > 5){
                    year = d.getFullYear() + 1;
                }
            }

            $('.unkostenbeitrag').text("0 €");
            $('#betragMitglieder').text(StringTool.format2Dez(settings.betragMitglieder));
            $('#betragNichtmitglieder').text(StringTool.format2Dez(settings.betragNichtmitglieder));
            $('#betragKinder').text(StringTool.format2Dez(settings.betragKinder));

            if(!settings?.enabled){
                $('#xxltreffenBody').hide();
                $('body').append('<h1>Die Online-Anmeldung zum XL-Treffen ist derzeit leider nicht möglich.</h1>')
            }
        });

        let $response = $('#response');
        let $responsetext = $('#responsetext');
        let $mainDiv = $('#maindiv');

        $response.hide();
        $mainDiv.show();

        jQuery('#sendButton').on('click', async () => {
            $response.hide();

            let request: XLAnmeldung = this.getRequest();
    

            let response = await fetch('servlet/xxlanmeldung', {
                method: "POST",
                body: JSON.stringify(request),
                headers: headers
            })

            let anmeldungResponse: XXLAnmeldungResponse = await response.json();

            $response.show();
            $mainDiv.hide();

            if(anmeldungResponse.status == 'OK'){
                $response.css('color','black');
                $('.xlok').show();
                $('.xlerror').hide();
            } else {
                $response.css('color', '#800000');
                $('.xlok').hide();
                $('.xlerror').show();
            }

            $responsetext.text(anmeldungResponse.message);


        });    

        jQuery('#backButton').on('click', () => {
            $response.hide();
            $mainDiv.show();
        });

        jQuery('.xl-form-outline>div>input').on('input', () => {
            this.validate();
        })

        this.validate();
    }

    validate(){
        let r = this.getRequest();
        this.setValid($('#rufname0'), r.rufname?.length > 0);
        this.setValid($('#anrede0'), r.anrede?.length > 0);
        this.setValid($('#familienname0'), r.familienname?.length > 0);
        this.setValid($('#abiturjahrgang0'), r.abiturjahrgang != null);
        
        $('.unkostenbeitrag').text(this.getUnkostenbeitrag());
    }

    getUnkostenbeitrag(): string {
        let mitglieder: number = 0;
        let nichtMitglieder: number = 0;
        let kinder: number = this.getAnzahlkinder();

        for(let i: number = 0; i < 3; i++){
            if(this.inputFieldHasText('rufname' + i) || this.inputFieldHasText('familienname' + i)){
                if(this.isChecked('fkmitglied' + i)){
                    mitglieder++;
                } else {
                    nichtMitglieder++;
                }
            } 
        }

        if(this.settings){
            let betrag = 0;
            betrag += this.settings.betragMitglieder * mitglieder;
            betrag += this.settings.betragNichtmitglieder * nichtMitglieder;
            betrag += this.settings.betragKinder * kinder;
            return StringTool.format2Dez(betrag) + " €";
        }

        return "(unbekannter Betrag)";
    }

    getAnzahlkinder(){
        let kinderText = $('#anzahlkinder').val() + "";
        if(kinderText.length > 0){
            try {
                return Number.parseInt(kinderText);
            } catch (ex){
                return 0;
            }
        }

        return 0;
    }

    isChecked(id: string){
        let field = $('#' + id);
        if(field.length == 0) return false;
        return field.is(':checked');
    }

    inputFieldHasText(id: string): boolean {
        let field = $('#' + id);
        if(field.length == 0) return false;
        let value: string = "" + <string>field.val();
        return value.length > 0;
    }

    setValid($element: JQuery<HTMLInputElement>, isValid: boolean){
        // $element[0].setCustomValidity(isValid ? '' : 'Invalid');
        $element.toggleClass('is-valid', isValid);
        $element.toggleClass('is-invalid', !isValid);
    }

    getAsNumber(id: string): number {
        let field = $('#' + id);
        if(field.length == 0) return 0;
        let s = field.val() + "";
        if(s.length == 0) return 0;
        try{
            return Number.parseInt(s);
        } catch (ex){
            return 0;
        }
    }

    getRequest(): XLAnmeldung {
        return {
            anrede: <string>$('#anrede0').val(),
            rufname: <string>$('#rufname0').val(),
            familienname: <string>$('#familienname0').val(),
            geburtsname: <string>$('#geburtsname0').val(),
            akademischerGrad: <string>$('#akadgrad0').val(),
            abiturjahrgang: this.getAsNumber('abiturjahrgang0'),
            istMitglied: this.isChecked("fkmitglied0"),
            
            anrede1: <string>$('#anrede1').val(),
            rufname1: <string>$('#rufname1').val(),
            familienname1: <string>$('#familienname1').val(),
            geburtsname1: <string>$('#geburtsname1').val(),
            akademischerGrad1: <string>$('#akadgrad1').val(),
            abiturjahrgang1: this.getAsNumber('abiturjahrgang1'),
            istMitglied1: this.isChecked("fkmitglied1"),
            
            anrede2: <string>$('#anrede2').val(),
            rufname2: <string>$('#rufname2').val(),
            familienname2: <string>$('#familienname2').val(),
            geburtsname2: <string>$('#geburtsname2').val(),
            akademischerGrad2: <string>$('#akadgrad2').val(),
            abiturjahrgang2: this.getAsNumber('abiturjahrgang2'),
            istMitglied2: this.isChecked("fkmitglied2"),

            anzahlKinder: this.getAnzahlkinder(),
            
            unkostenbeitrag: this.getUnkostenbeitrag(),

            tel: <string>$('#tel').val(),
            mail: <string>$('#mail').val(),
            anschrift: <string>$('#anschrift').val(),
            zustimmungZurSpeicherung: this.isChecked("speicherung1ja")
        }
    }

}

new XLTreffen();